import http from "./http-common";

class ToursServiceClass {
    private path = '/tours'
    list() {
        return http.get(this.path)
    }

    getDetailTourInfo(tour_id: string, agency_id: string) {
        return http.get(`${this.path}/info/detail/${tour_id}/${agency_id}`)
    }
}

const ToursService = new ToursServiceClass()

export default ToursService;